/* ================================================== */
/* ACCESSIBILITY → Languages
/* ================================================== */

function accessibilityLanguages() {
	if ($('#layout--header').hasClass('sticked')) {
		$('.languages__link').attr('tabindex', '-1');
	} else {
		$('.languages__link').attr('tabindex', '0');
	}
}

$(document).ready(function() {
	$(window).on('resize orientationchange', function() {
		accessibilityLanguages();
	});

	$(window).scroll(function() {
		accessibilityLanguages();
	});
});